import { Button } from "../../../components/Buttons";
import { headerList } from "../../../utils/constant";
import { NewProcedure } from "../../../containers/steps";
import { useModal } from "../../../contexts/ModalContext";
import { useNavigate, useParams } from "react-router-dom";
import CallServiceTable from "../../../components/Tables/CallServiceTable";
import { useDialog } from "../../../contexts/DialogContext";
import { generateYearsArray } from "../../../utils/validate";
import { FormQuotes } from "../../../containers/ManegeProcedure/FormQuotes";
import ServiceOrderPDF from "../../../containers/ManegeProcedure/ServiceOrderPDF";
import CustomsClearanceQuote from "../../../containers/ManegeProcedure/CustomsClearanceQuote";
import { requestAuth } from "../../../components/services/RequestService";
import { Anchor, H3 } from "../../../components/Text";
import CustomsClearancePdf from "../../../containers/ManegeProcedure/CustomsClearancePdf";

const FolderList = () => {
  const { rolId } = useParams();
  const navigate = useNavigate();
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();

  function handleAdd(reload) {
    openModal(<NewProcedure reload={reload} onClose={onClose} />);
  }

  function handleFolderStep(procedure) {
    navigate(`/rol/${rolId}/menu/folderList/step-procedure/${procedure.id}`);
  }

  async function getNotesValueData(procedure) {
    try {
      const fieldsResponse = await requestAuth(
        "get",
        `/Procedure/${
          procedure.id || procedure.procedureId
        }/datasets?fieldnames=notaDeValor`
      );
      const notaDeValorField = fieldsResponse.data?.find(
        (field) => field.name === "notaDeValor"
      );

      if (notaDeValorField) {
        const notesResponse = await requestAuth(
          "get",
          `/dataSet/procedure/${procedure.id || procedure.procedureId}/field/${
            notaDeValorField.id
          }/subdata`
        );
        return notesResponse.data;
      }
      return [];
    } catch (error) {
      console.error("Error obteniendo datos de notas de valor:", error);
      return [];
    }
  }

  async function handleFormQuotes(procedure) {
    const notesValueData = await getNotesValueData(procedure);
    openDialog(
      <CustomsClearanceQuote
        procedure={procedure}
        notesValueData={notesValueData}
      />
    );
    // openModal(<FormQuotes procedure={procedure} />);
  }

  function generateServiceOrder(procedure) {
    openDialog(<ServiceOrderPDF procedure={procedure} />);
  }

  function generateCustomsClearanceForm(procedure) {
    console.log("🚀 ~ generateCustomsClearanceForm ~ procedure:", procedure);
    if (procedure.category === "multiple") {
      var win = window.open(
        `/rol/${rolId}/procedure-type/${1}/step/1/procedure/${
          procedure.procedureId || procedure.id
        }/generate/clone-items`,
        // `/rol/${rolId}/procedure-type/${procedure.procedureTypeId}/step/1/procedure/${procedure.id}/generate/clone-items`,
        "_blank"
      );
      win.focus();
      openDialog(
        <div className="w-[400px]">
          <H3 className="text-[1.4rem]">
            El tramite {procedure.number} es un tramite multiple
          </H3>
          <center>
            <Anchor
              className="text-[#264fbe] text-[1.2rem]"
              href={`/rol/${rolId}/procedure-type/${1}/step/1/procedure/${
                procedure.procedureId || procedure.id
              }/generate/clone-items`}
              // download
              target="_blank"
              rel="noopener noreferrer"
            >
              Ir a la pagina de items
            </Anchor>
          </center>
          <br />
        </div>
      );
    } else {
      openDialog(
        <CustomsClearancePdf
          procedure={{
            ...procedure,
            procedureId: procedure.procedureId || procedure.id,
          }}
        />
      );
    }
  }

  return (
    <CallServiceTable
      component={({ reload }) => {
        return <Button onClick={() => handleAdd(reload)}>Nueva carpeta</Button>;
      }}
      // onClick={handleFolderStep}
      filters={[
        {
          name: "procedureType",
          url: "/procedureType",
          default: "Todos los tramites",
          valueOption: "id",
          labelOption: "name",
        },
        {
          name: "companyId",
          url: "/company/getallcompanies",
          default: "Todas las compañías",
          valueOption: "id",
          labelOption: "razonSocial",
        },
        {
          name: "Year",
          default: "Todas las gestiones",
          options: generateYearsArray(),
        },
        {
          name: "canal(Rojo,AmarilloOVerde)",
          label: "Canal",
          default: "Todos los canales",
          options: [
            {
              label: "Canal Rojo",
              name: "Canal Rojo",
            },
            {
              label: "Canal Amarillo",
              name: "Canal Amarillo",
            },
            {
              label: "Canal Verde",
              name: "Canal Verde",
            },
          ],
        },
      ]}
      urlApi="/procedure/openprocedures"
      addFilters={[
        // {
        //   name: "procedureNumber",
        //   label: "Tramite",
        //   filter: true,
        // },
        {
          name: "internCode",
          label: "Nro. interno",
          filter: true,
        },
        {
          name: "dimNumber",
          label: "Nro. DIM/DEX",
          filter: true,
        },
        {
          name: "product",
          label: "Mercadería",
          filter: true,
        },
      ]}
      header={[
        ...headerList,
        {
          name: "Reports",
          type: "action",
          label: "Reportes",
          sticky: true,
          actions: [
            {
              label: "Lista de Pasos",
              icon: "fas fa-shoe-prints",
              action: handleFolderStep,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Hoja de trabajo",
              icon: "fas fa-print",
              action: generateServiceOrder,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Cotización",
              icon: "fas fa-hand-holding-usd",
              action: handleFormQuotes,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Planilla",
              icon: "fas fa-file-contract",
              action: generateCustomsClearanceForm,
              color: "text-[#1d4ed8]",
            },
            // {
            //   label: "Generar hoja de ruta",
            //   icon: "fas fa-route",
            //   action: generateRoadmap,
            //   color: "text-[#1d4ed8]",
            // },
          ],
        },
      ]}
    />
  );
};

export default FolderList;
